import { createSlice } from '@reduxjs/toolkit';

interface ContactSlice {
  contact: {
    id: string;
    createdAt?: string;
    updatedAt?: string;
    workspaceId?: string;
    name?: string;
    phoneNumber?: string;
    email?: string;
    address?: string;
    groups?: Array<string>;
    ContactList: any;
    contacts: Array<{ phone_number: string; customer_name: string }>;
    type: string;
    groupName: string;
    selectedGroup: Array<string>;
    rawFile: any;
  };
}

const initialState: ContactSlice = {
  contact: {
    id: '',
    createdAt: '',
    updatedAt: '',
    workspaceId: '',
    name: '',
    phoneNumber: '',
    email: '',
    address: '',
    groups: [],
    ContactList: [],
    contacts: [],
    type: 'none',
    groupName: '',
    selectedGroup: [],
    rawFile: '',
  },
};

export const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    selectContact: (state, { payload }) => {
      state.contact = { ...payload, header: {} };
    },
    resetContact: (state) => {
      state.contact = initialState.contact;
    },
    setContact: (state, action) => {
      state.contact = action.payload;
    },
    removeContact: (state) => {
      // @ts-ignore
      state.contact = { id: '' };
    },
    setRawFile: (state, action) => {
      state.contact.rawFile = action.payload;
    },
  },
});

export const {
  setContact,
  removeContact,
  resetContact,
  selectContact,
  setRawFile,
} = contactSlice.actions;

export default contactSlice.reducer;
